import React from 'react';
import PropTypes from 'prop-types';

import {Box, Skeleton, Stack} from 'views/components';

const CohortGraphSkeleton = (props) => {
  const {
    chartHeight = 260,
    showSummary = true,
  } = props;

  return (
    <Box sx={{width: '100%'}}>
      {
        showSummary &&
        <>
          <Skeleton variant='text' width='32%' height={22} />
          <Skeleton variant='text' width='46%' height={20} sx={{mb: 1.5}} />
        </>
      }
      <Box
        sx={{
          border: '1px solid #EBE6DE',
          borderRadius: 3,
          backgroundColor: '#FFFDFC',
          px: 1,
          pt: 1.5,
          pb: 1,
        }}
      >
        <Stack spacing={1.25}>
          <Skeleton variant='rounded' width='100%' height={chartHeight} />
          <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 1, px: 0.5, py: 1}}>
            {
              Array.from({length: 6}).map((x, index) => {
                return <Skeleton key={index} variant='rounded' width={index === 0 ? 92 : 120} height={32} />;
              })
            }
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

CohortGraphSkeleton.propTypes = {
  chartHeight: PropTypes.number,
  showSummary: PropTypes.bool,
};

export default React.memo(CohortGraphSkeleton);
